import { useState, useEffect, createPortal } from "@wordpress/element";
import { dispatch } from '@wordpress/data';
import Popup from "./Popup";

export default function AddToCart( { competition, qty, children } ) {

	const [popup_open, setPopupOpen] = useState( false );
	const [added, setAdded] = useState( false );
	const [loading, setLoading] = useState( false );
	const [error, setError] = useState( false );
	const [answer, setAnswer] = useState( null );
	const [qtySelect, setQtySelect] = useState(qty);
    const [portalRoot, setPortalRoot] = useState( null );

    useEffect( () => {
        setPortalRoot( ensurePortalRoot() );
    }, [] );

    /**
     * Ensure and return the portal root element used for React portals.
     *
     * @returns {HTMLElement|null} Portal root element or null if not in a browser.
     */
    const ensurePortalRoot = () => {

        const portal_id = 'zap-upsell-portal-root';

        if ( 'undefined' === typeof document ) {
            return null;
        }

        const existing = document.getElementById( portal_id );
        if ( null !== existing ) {
            return existing;
        }

        const el = document.createElement( 'div' );
        el.id = portal_id;
        document.body.appendChild( el );

        return el;
    };

	const AddToCart = async ( product_id ) => {

		// If the competition has a question, show the popup.
		if( competition.question ){
			setPopupOpen(true);
			return;
		}

		// Send regular add to cart.
		SendAddToCart( product_id, qty );
	}

	const SendAddToCart = async ( product_id, qty = 1, answer = null ) => {
		setLoading( true );

		try{

			// Add to cart.
			const res = await fetch("/wp-json/wc/store/v1/cart/add-item", {
				method: 'POST',
				credentials: 'include',
				headers: {
					'Content-Type': 'application/json',
					'Nonce': window.checkout_v2.checkout_v2_nonce,
				},
				body: JSON.stringify({
					'id': product_id,
					'quantity': qty,
					'_answer': answer,
				})
			});

			if (!res.ok) throw new Error("Network response was not ok");

			// Set the check mark icon + clear after 2s.
			setAdded( true );
			setTimeout( () => setAdded(false), 2000 );

		} catch(error){

			// Set icon + clear after 2s.
			setError(true);
			setTimeout( () => setError(false), 2000 );

			// Log error - more needed here UX-wise.
			console.error(error);

		} finally{

			// Stop the loading spinner.
			setLoading( false );

			// Update the cart.
			dispatch( 'wc/store/cart' ).invalidateResolutionForStore();

			// If any popup open, then close.
			setPopupOpen(false);
		}
	}

	// Add body class if popup open.
	if( popup_open ){
		document.body.classList.add( 'zapc-popup-open' );
	} else {
		document.body.classList.remove( 'zapc-popup-open' );
	}

	function handleClosePopup( e ){
		e.preventDefault();
		setPopupOpen(false);
	}

	return (
		<>
			<button
				type="button"
				onClick={()=>{ AddToCart( competition.product_id ) }}
				className="zapc-checkout-button green"
				aria-label={loading ? "Adding..." : added ? "Added" : error ? "Error" : "Add to cart"}
			>
				{ ! loading && ! added && ! error && ( children ) }
				{ ! loading && added && ( <i style={{margin: 0}} className="fa fa-check"></i> ) }
				{ loading && ( <i style={{margin: 0}} className="fa fa-spinner fa-spin"></i> ) }
				{ error && ( <i style={{margin: 0}} className="fa fa-warning"></i> ) }
			</button>
            { popup_open && portalRoot && createPortal(
				<Popup title={"Add to Cart"} onClose={handleClosePopup} >
					<div className="add-to-cart-question">
						<h3>{competition.question}</h3>
						<div className="add-to-cart-question-answers">
							{ competition.answers.map( (answer_option, i) => {
								return (
									<button
										type="button"
										onClick={() =>{ setAnswer(answer_option) }}
										className={(answer_option === answer) ? "zapc-checkout-button block green solid" : "zapc-checkout-button block"}
										key={i}
									>
										{answer_option}
									</button>
								)
							}) }
						</div>
						<div className="add-to-cart-submit">
							<label>Tickets
								<input className="zap-checkout-field" type="number" name="qty" value={qtySelect} min={1} max={competition.stock} onChange={( event ) => { setQtySelect(event.target.value || qty) }} />
							</label>

							<button
								type="button"
								className="zapc-checkout-button green solid"
							onClick={()=>{ SendAddToCart( competition.product_id, qtySelect, answer ) }}>
								{ ! loading && ! added && ! error && ( "Add to Cart" ) }
								{ ! loading && added && ( <i style={{margin: 0}} className="fa fa-check"></i> ) }
								{ loading && ( <i style={{margin: 0}} className="fa fa-spinner fa-spin"></i> ) }
								{ error && ( <i style={{margin: 0}} className="fa fa-warning"></i> ) }
							</button>
						</div>
					</div>
				</Popup>,
                portalRoot
            )}
		</>
	);
}